import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const TRACKING_ID = "G-TQVXXCVBYQ"; // Sostituisci con il tuo ID

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Inizializza GA4 solo una volta
    ReactGA.initialize(TRACKING_ID);
  }, []);

  useEffect(() => {
    // Traccia la visualizzazione della pagina
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null; // Il componente non deve renderizzare nulla
};

export default Analytics;
